// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33YeL","footer":"styles_footer__2ZbTo"};